import { jwtDecode } from "jwt-decode";

import Menu from "../../components/menu/Menu";
import MenuGeral from "../../components/menu/MenuGeral";

function Welcome() {

  let decoded = null;
  const isAuth = localStorage.getItem("token") !== null;
  if (isAuth) decoded = jwtDecode(localStorage.getItem("token"));

  return (
    <>
      <div className="container">
        { decoded && decoded.isAdmin ? <Menu /> : <MenuGeral />}
        <div className="text-center pt-5">Welcome</div>
      </div>
    </>
  );
}

export default Welcome;
